import { createSlice, Middleware } from "@reduxjs/toolkit"
import { IPersonalInformation } from "./types"

type initialState = {
  response: IPersonalInformation | null
}

export const personalInformationSlice = createSlice({
  name: "personalInformation",
  initialState: { response: null } as initialState,
  reducers: {
    setPersonalInformation(state, action) {
      state.response = action.payload
    }
  }
})

export const { setPersonalInformation } = personalInformationSlice.actions
export default personalInformationSlice.reducer

export const personalInformationHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
